import React from 'react';
import { FadeIn } from './FadeIn';
export function Qualifier() {
  return <section className="py-20 px-4 bg-carbon-950 border-t border-carbon-800 blueprint-grid" data-id="element-202">
      <div className="max-w-3xl mx-auto text-center bg-carbon-900 border border-carbon-800 rounded-[2.5rem] p-8 sm:p-16 relative overflow-hidden" data-id="element-203">
        <FadeIn data-id="element-204">
          <h2 className="text-3xl sm:text-4xl font-display text-white mb-8 uppercase tracking-wide" data-id="element-205">
            Pero antes de decirte el precio, necesito ser directo con vos.
          </h2>
          <div className="space-y-6 text-lg text-carbon-300 font-sans leading-relaxed text-left" data-id="element-206">
            <p data-id="element-207">
              Este método{' '}
              <strong className="text-white font-semibold border-b border-electric" data-id="element-208">
                no es
              </strong>{' '}
              para quien busca resultados en 30 días sin esfuerzo ni compromiso
              real.
            </p>
            <p data-id="element-209">
              Es para el atleta que está dispuesto a seguir un sistema. Que va a
              abrir el Tomo 1 esta semana y va a repensar cómo entiende el
              entrenamiento. Que va a implementar la evaluación inicial, elegir
              su plan y empezar el primer bloque sin modificar todo antes de
              probarlo.
            </p>
            <p data-id="element-210">
              Es para quien entiende que fuerza y resistencia no son opuestos y
              que un cuerpo verdaderamente completo requiere un sistema que
              trabaje las dos cosas al mismo tiempo con inteligencia.
            </p>
            <div className="pt-8 mt-8 border-t border-carbon-800 text-center" data-id="element-211">
              <p className="text-white font-display text-2xl uppercase tracking-wide mb-2" data-id="element-212">
                Si eso sos vos, este método va a cambiar la forma en que
                entrenás.
              </p>
              <p className="text-electric font-display text-2xl uppercase tracking-wide" data-id="element-213">
                No en tres meses. Desde la primera semana.
              </p>
            </div>
            <p className="text-xs text-carbon-500 mt-8 uppercase tracking-widest font-mono text-center" data-id="element-214">
              Si no estás listo para implementarlo, no te lo vendas a vos mismo.
              No es para guardar. Es para usar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}